<div class="fonm-group row">
    <label class="col-md-2"><b>Bodega:</b></label> 
    <ng-select class="col-md-4" name="branch" [(ngModel)]="selectedBranch" [disabled]="disabled"  (change)="selectBranch()" [selectOnTab]="true">
        <ng-option *ngFor="let deliveryBranch of branch.deliveryBranches" [value]="deliveryBranch" >
          [{{deliveryBranch.code}}] {{deliveryBranch.name}}</ng-option>
    </ng-select>

    <button class="btn btn-primary" [disabled]="disableButton()" (click)="show()">Validar Stock</button>
</div>
